const formElement = document.getElementsByClassName("follow-scroll-form")[0];
const scrollLeftSection =  document.getElementsByClassName("form-scroll-left-section")[0];
const requirementContainerElement = document.getElementsByClassName("requirements-container")[0];

document.addEventListener('scroll', function (e) {
  if(formElement) {
    const scrollLeftSectionRect = scrollLeftSection.getBoundingClientRect();

    const formRect = formElement.getBoundingClientRect();

    let formTopOffset = -scrollLeftSectionRect.top;
    const maxTopOffset = scrollLeftSectionRect.height - formRect.height - 100 - 20; // 100 is the margin that the right column has at the top. 20 is margin on avantages

    if (formTopOffset > 0) {
      if (formTopOffset > maxTopOffset) {
        formTopOffset = maxTopOffset;
      }
      formElement.style.top = (formTopOffset) + 'px';
    }
  }
})